$(document).on('click', '.book_time', async function () {
    renderLoadingOverlay();
    let booking_button = $(this);
    const court_id     = $(this).data('court-id');
    const location_id  = $(this).data('location-id');
    const date         = $(this).data('date');
    const time         = $(this).data('time');
    const duration     = $(this).data('duration');

    console.log(location_id, user_id, court_id, date, time, duration);
    await bookTime(location_id, court_id, date, time, duration, booking_button);
    removeLoadingOverlay();


})

const bookTime = async (location_id, court_id, date, time, duration, booking_button) => {
    try {
        const response        = await fetch(`/api/book_time`, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body:    JSON.stringify({
                json:        true,
                user_id:     user_id,
                court_id:    court_id,
                date:        date,
                time:        time,
                duration:    duration,
                location_id: location_id,
            })
        });
        const bookingResponse = await response.json()

        console.log(booking_button)
        if (bookingResponse.booked) {
            booking_button.removeClass('time_available').addClass('time_reserved')
            notify(bookingResponse.message, 'green', 2000);
        }

        if (bookingResponse.unbooked) {
            $(booking_button).removeClass('time_reserved').addClass('time_available')
            notify(bookingResponse.message, 'green', 2000);
        }

        if (bookingResponse.booking_slot) {
            booking_button.removeClass('time_available').addClass('time_confirmed')
            notify(bookingResponse.message, 'yellow', 2000);
        }
        showReservedDateOnCalendar(location_id)
        renderReservations()
    } catch (error) {
        console.log(error)
    }
}
